import UPDATE_MY_ALERTS_MODAL_SLOT from '../actionTypes/MyAlertsModalActionTypes';

function MyAlertsModalReducer(state = null, action) {
    switch (action.type) {
        case UPDATE_MY_ALERTS_MODAL_SLOT:
            return action.payload ? action.payload.slot : null;
        default:
            return state;
    }
}

export default MyAlertsModalReducer;
